export const STREET_TYPE_AU: Record<string, string> = {
    St: 'Street',
    Rd: 'Road',
    Ave: 'Avenue',
    Blvd: 'Boulevard',
    Dr: 'Drive',
    Ct: 'Court',
    Cres: 'Crescent',
    Hwy: 'Highway',
    Way: 'Way',
    Pl: 'Place',
    Ln: 'Lane',
    Cct: 'Circuit',
    Tce: 'Terrace',
    Pde: 'Parade',
    Sq: 'Square',
    Aly: 'Alley',
    Cl: 'Close',
    Mews: 'Mews',
} as const;
